
import axios from "axios";
import AppStorageService from "./services/app-storage.service";

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "Content-type": "application/json",
  }
});

http.interceptors.request.use((config) => {
  const user = AppStorageService.getUser();
  if (user?.accessToken) {
    config.headers = config.headers || {};
    if (!config.headers["x-access-token"]) {
      config.headers["x-access-token"] = user.accessToken;
    }
  }
  return config;
});

export default http;
